const state = {
  // Name of the bucket whose read requests were rejected with AccessDenied (usually by the bucket policy)
  s3AccessDeniedBucket: null,
  // Bumped on every reset; requests stamped with an older value (e.g. from the previous tab) are ignored
  s3RequestGeneration: 0,
};

const getters = {
  s3AccessDeniedBucket(state) {
    return state.s3AccessDeniedBucket;
  },
  s3RequestGeneration(state) {
    return state.s3RequestGeneration;
  },
};

const actions = {
  updateS3AccessDeniedBucket({ commit }, s3AccessDeniedBucket) {
    commit('UPDATE_S3_ACCESS_DENIED_BUCKET', s3AccessDeniedBucket);
  },
  resetS3AccessDenied({ commit }) {
    commit('RESET_S3_ACCESS_DENIED');
  },
};

const mutations = {
  UPDATE_S3_ACCESS_DENIED_BUCKET(state, s3AccessDeniedBucket) {
    state.s3AccessDeniedBucket = s3AccessDeniedBucket;
  },
  RESET_S3_ACCESS_DENIED(state) {
    state.s3AccessDeniedBucket = null;
    state.s3RequestGeneration += 1;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
